
import { ResellerOrder, WaitingPeriodStatus } from "@/types/resellerOrder";

// Export common types used across reseller order modules
export type ActivationResult = { 
  success: boolean; 
  message?: string; 
  licenseKey?: string; 
  accountNumber?: string;
  superAdminUrl?: string;
  credentials?: { email: string; password: string };
  testAccountCredentials?: { 
    admin: { email: string; password: string }; 
    user: { email: string; password: string } 
  };
};

export type PaymentVerificationResult = { 
  verified: boolean; 
  message?: string 
};

// In-memory storage for order data
// This would be replaced with API calls in production
export let resellerOrders: ResellerOrder[] = [
  {
    id: "order-1744959083503",
    orderNumber: "RP083503660",
    businessName: "Acme Marketing",
    businessEmail: "contact@acmemarketing.com",
    contactName: "John Doe",
    contactEmail: "john@acmemarketing.com",
    contactPhone: "(555) 123-4567",
    plan: "pro",
    domain: "acme.referme.site",
    orderDate: new Date(),
    status: "pending",
    paymentAmount: 999,
    paymentMethod: "credit_card",
    businessAddress: {
      street: "123 Main St",
      city: "San Francisco",
      state: "CA",
      zip: "94105",
      country: "USA"
    },
    transactionId: "txn_123456789",
    scheduledActivationTime: new Date(Date.now() + 5 * 60 * 1000),
    waitingPeriod: "active",
    paymentVerified: true,
    notes: "Pending approval from master admin"
  },
  {
    id: "order-1744959083504",
    orderNumber: "RP083503561",
    businessName: "Tech Solutions Inc",
    businessEmail: "info@techsolutions.co",
    contactName: "Jane Smith",
    contactEmail: "jane@techsolutions.co",
    contactPhone: "(555) 987-6543",
    plan: "pro",
    domain: "tech.referme.site",
    orderDate: new Date(),
    status: "pending",
    paymentAmount: 999,
    paymentMethod: "bank_transfer",
    businessAddress: {
      street: "456 Market St",
      city: "New York",
      state: "NY",
      zip: "10001",
      country: "USA"
    },
    transactionId: "txn_987654321",
    scheduledActivationTime: new Date(Date.now() + 5 * 60 * 1000),
    waitingPeriod: "active",
    paymentVerified: true,
    notes: "Received payment confirmation"
  }
];
